/* @flow */
import React, { Fragment } from 'react'
import styled from 'styled-components'
import { DEVICES, SIZES } from '../../../constants/index'

const LogoWrapper = styled.div`
  margin-right: 15px;
  padding: 0;
  width: 100px;

  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    flex: 1 1 227px;
    display: -ms-flexbox;
    -ms-flexbox: 1 1 227px;
    max-width: 227px;
    position: relative;
  }

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    min-width: 110px;
  }
`

const ChristmasWishLink = styled.div`
  position: absolute;
  top: ${props => props.theme.header.holidayLogo.top}%;
  width: 100%;
  height: 48%;
  z-index: 1;
`

const LogoImg = styled.img`
  height: auto;
  width: 179px;
  
  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    bottom: ${props => props.theme.header.logo.bottom}px;
    position: absolute;
  }

  @media (min-width: ${SIZES.BREAKPOINT_MD}px) {
    height: auto;
    bottom: ${props => props.isFixed ? 0 : props => props.theme.header.logo.bottom}px;
  }

  @media (max-width: ${SIZES.BREAKPOINT_XS}px) {
    width: 100px;
  }
`

declare var STATICS_PATH: string

type Props = {|
  activeDynamicLayout: string,
  isFixed: boolean,
  widget: {
    meta: {
      link: {
        location?: string,
        text?: string,
        src?: string,
        christmasLogo?: string
      }
    }
  }
|}

export default (props: Props) => {
  const {
    activeDynamicLayout,
    isFixed,
    widget: {
      meta: {
        link: {
          location = '.',
          text = '',
          src = '',
          christmasLogo = ''
        }
      }
    }
  } = props

  return (
    <LogoWrapper>
      {
        (activeDynamicLayout === DEVICES.DESKTOP) && !isFixed
          ? (
            <Fragment>
              <a href='https://www.centrum.cz/posilejte-prani/?utm_medium=vanoce'>
                <ChristmasWishLink/>
              </a>
              <a href={location}>
                <LogoImg isFixed={!isFixed} src={`${STATICS_PATH}${christmasLogo}`} alt={text} title={text}/>
              </a>
            </Fragment>
          )
          : (
            <a href={location}>
              <LogoImg isFixed={!isFixed} src={`${STATICS_PATH}${src}`} alt={text} title={text}/>
            </a>
          )
      }
    </LogoWrapper>
  )
}
